/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserMenuContainer_app$ref: FragmentReference;
export type UserMenuContainer_app = {|
  +referralVcReward: ?number,
  +$refType: UserMenuContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserMenuContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "referralVcReward",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '858779025ef331f3a6ee835602f68d08';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/User/__generated__/UserMenuContainer_app.graphql.js